import { data as developmentBlogData } from '@/profiles/development.blog.js';
import { data as developmentResourcesData } from '@/profiles/development.resources.js';
import { data as proxyBlogData } from '@/profiles/proxy.blog.js';

import { data as previewData } from '@/profiles/preview.js';
import { data as previewOverideData } from '@/profiles/preview-override.js'; // Common Preview settings instead of duplicating in each profile
import { data as qaData } from '@/profiles/qa.js';

// Add each site profile here
import { data as corpBlogData } from '@/profiles/corporate.blog.js';
import { data as corpResourcesData } from '@/profiles/corporate.resources.js';

import { data as constBlogData } from '@/profiles/construction.blog.js';
import { data as constResourcesData } from '@/profiles/construction.resources.js';


import { data as sketchupBlogData } from '@/profiles/sketchup.blog.js';
import { data as sketchupResourcesData } from '@/profiles/sketchup.resources.js';
import { data as geospatialBlogData } from '@/profiles/geospatial.blog.js';
import { data as geospatialResourcesData } from '@/profiles/geospatial.resources.js';
import { data as opsBlogData } from '@/profiles/ops.blog.js';
import { data as opsResourcesData } from '@/profiles/ops.resources.js';
import { data as positioningBlogData } from '@/profiles/positioning.blog.js';
import { data as positioningResourcesData } from '@/profiles/positioning.resources.js';

const corporateBlogPreview = { ...corpBlogData, ...previewOverideData };
const corporateResourcesPreview = { ...corpResourcesData, ...previewOverideData };

const constructionBlogPreview = { ...constBlogData, ...previewOverideData };
const constructionResourcesPreview = { ...constResourcesData, ...previewOverideData };

export const getProfile = (profile = 'all') => {
  const profileMapping = {
    'development-blog': developmentBlogData,
    'development-resources': developmentResourcesData,

    'corporate-blog': corpBlogData,
    'corporate-blog-preview': corporateBlogPreview,
    'corporate-resources': corpResourcesData,
    'corporate-resources-preview': corporateResourcesPreview,

    'construction-blog': constBlogData,
    'construction-blog-preview': constructionBlogPreview,
    'construction-resources': constResourcesData,
    'construction-resources-preview': constructionResourcesPreview,
    
    'sketchup-blog': sketchupBlogData,
    'sketchup-resources': sketchupResourcesData,
    'geospatial-blog': geospatialBlogData,
    'geospatial-resources': geospatialResourcesData,
    'ops-blog': opsBlogData,
    'ops-resources': opsResourcesData,
    'positioning-blog': positioningBlogData,
    'positioning-resources': positioningResourcesData,
    'preview': previewData,
    'qa': qaData,
    'proxy': proxyBlogData,
  };

  const additionalEnvVariables = [
    "EXTRA_ENV_VAR",
  ]

  // if a value is in env then use it. Also those env values need to be cast as boolean or number if needed.
  const selectedProfile = profileMapping[profile] || developmentBlogData; // should this be 'developmentData' instead of 'developmentBlogData'? build errors out with it.
  Object.keys(selectedProfile).forEach((key) => {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      if(envValue === 'false' || envValue === false) {
        selectedProfile[key] = false;
      } else if(envValue === 'true' || envValue === true) {
        selectedProfile[key] = true;
      } else if(!isNaN(envValue)) {
        selectedProfile[key] = Number(envValue);
      } else {
        selectedProfile[key] = envValue;
      }
    }
  });
  for(const key of additionalEnvVariables) {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      selectedProfile[key] = envValue;
    }
  }

  return selectedProfile;
}

const layerProfiles = (profile1, profile2) => {
  for(const key of additionalEnvVariables) {
    const envValue = process.env[key] || selectedProfile[key];
    if (envValue) {
      selectedProfile[key] = envValue;
    }
  }
}